import { BaseQueryFn, createApi, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { getSettings, SettingsState } from '..';
import { Credentials, LoginResponse, User, UserResponse } from '../models/auth';
import { fetchQueryWithToken } from './auth.helpers';

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const settings = getSettings(api.getState() as SettingsState);
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${settings?.servers.serverAuth ?? ''}/api/v1/auth/${urlEnd}`;
  return fetchQueryWithToken(typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl }, api, extraOptions);
};

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Login'],
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, Credentials>({
      query: body => ({ url: 'login', method: 'POST', body }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({ url: 'logout', method: 'POST' }),
    }),
    getAuth: builder.query<User, void>({
      query: () => ({
        url: 'me',
      }),
      providesTags: ['Login'],
      transformResponse: (response: UserResponse) => response?.data,
    }),
  }),
});

export const { useGetAuthQuery, useLoginMutation, useLogoutMutation } = authApi;
